var map = {
	"./chat.svg": "7c91",
	"./diz.svg": "0f36",
	"./end-full-screen.svg": "2f7a",
	"./facebook.svg": "1c90",
	"./full-screen.svg": "82d0",
	"./heart-fill.svg": "97d3",
	"./heart.svg": "ea3d",
	"./instagram.svg": "3999",
	"./left-arrow.svg": "67d4",
	"./like.svg": "2a68",
	"./pause.svg": "321d",
	"./pip-end.svg": "66c2",
	"./pip.svg": "cc10",
	"./play.svg": "b803",
	"./right.svg": "6ad5",
	"./share.svg": "af36",
	"./true.svg": "1fff",
	"./twitter.svg": "ee44",
	"./v-1.svg": "3ecb",
	"./v-2.svg": "7cbf",
	"./v-3.svg": "34c8",
	"./v-off.svg": "066c",
	"./whats-app.svg": "3a1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7906";